<template>
  <v-container fluid class="grey lighten-2">
    <v-row>
      <v-col class="mt-2" cols="12">
        <v-dialog v-model="dialog" max-width="800" scrollable persistent transition="dialog-bottom-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">
              <v-icon id="medical">{{ icon }}</v-icon>{{ phrase.title_medical }}
            </v-btn>
          </template>

          <v-card height=400>
            <v-card-title class="text-h5 grey lighten-2">{{ phrase.title_medical }}</v-card-title>
            <v-card-text style="white-space: pre-line">
              <div class="my-5 text--primary">{{ help_medical_text }}</div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-start">
              <v-btn color="primary" text @click="dialog = false">
                {{ phrase.dialog_close }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <span class="ml-4 font-weight-bold header-total-inline">合計 {{ (this.$store.state.breakdown.medical_medicine_internal + this.$store.state.breakdown.medical_medicine_analgesic + this.$store.state.breakdown.medical_medicine_external + this.$store.state.breakdown.medical_medicine_etc + this.$store.state.breakdown.medical_medicine_supplement + this.$store.state.breakdown.medical_medicine_children + this.$store.state.breakdown.medical_physical.reduce((sum, i) => { return sum + i.order; }, 0)).toLocaleString() }}円</span>
      </v-col>
      <v-col>
        <v-sheet
          color="grey lighten-2"
          elevation="10"
        >
          <v-col>医薬品</v-col>
          <v-col>
            <v-row>
              <v-col class="mt-2 d-flex" cols="12" sm="6" md="3" lg="3">
                <v-card class="d-flex flex-column flex-grow-1">
                  <v-card-title>内服薬</v-card-title>
                  <v-layout justify-center>
                    <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/medical/medical_medicine_internal.jpg')"></v-img>
                  </v-layout>
                  <v-select small-chips multiple class="d-inline-flex align-center mt-2 ml-4" v-model="$store.state.select.medical_medicine.internal" :items=this.$store.state.login_response.medical_medicine_internal item-text="select" item-value="id" return-object label="選択してください" @change="value_medical_medicine_internal"></v-select>
                  <v-card-subtitle>小計{{ this.$store.state.breakdown.medical_medicine_internal.toLocaleString() }}円</v-card-subtitle>
                </v-card>
              </v-col>
              <v-col class="mt-2 d-flex" cols="12" sm="6" md="3" lg="3">
                <v-card class="d-flex flex-column flex-grow-1">
                  <v-card-title>鎮痛薬</v-card-title>
                  <v-layout justify-center>
                    <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/medical/medical_medicine_analgesic.jpg')"></v-img>
                  </v-layout>
                  <v-select small-chips multiple class="d-inline-flex align-center mt-2 ml-4" v-model="$store.state.select.medical_medicine.analgesic" :items="analgesic_items" item-text="select" item-value="id" return-object label="選択してください" @change="value_medical_medicine_analgesic"></v-select>
                  <v-card-subtitle>小計{{ this.$store.state.breakdown.medical_medicine_analgesic.toLocaleString() }}円</v-card-subtitle>
                </v-card>
              </v-col>
              <v-col class="mt-2 d-flex" cols="12" sm="6" md="3" lg="3">
                <v-card class="d-flex flex-column flex-grow-1">
                  <v-card-title>外用薬等</v-card-title>
                  <v-layout justify-center>
                    <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/medical/medical_medicine_external.jpg')"></v-img>
                  </v-layout>
                  <v-select small-chips multiple class="d-inline-flex align-center mt-2 ml-4" v-model="$store.state.select.medical_medicine.external" :items=this.$store.state.login_response.medical_medicine_external item-text="select" item-value="id" return-object label="選択してください" @change="value_medical_medicine_external"></v-select>
                  <v-card-subtitle>小計{{ this.$store.state.breakdown.medical_medicine_external.toLocaleString() }}円</v-card-subtitle>
                </v-card>
              </v-col>
              <v-col class="mt-2 d-flex" cols="12" sm="6" md="3" lg="3">
                <v-card class="d-flex flex-column flex-grow-1">
                  <v-card-title>その他</v-card-title>
                  <v-layout justify-center>
                    <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/medical/medical_medicine_etc.jpg')"></v-img>
                  </v-layout>
                  <v-select small-chips multiple class="d-inline-flex align-center mt-2 ml-4" v-model="$store.state.select.medical_medicine.etc" :items=this.$store.state.login_response.medical_medicine_etc item-text="select" item-value="id" return-object label="選択してください" @change="value_medical_medicine_etc"></v-select>
                  <v-card-subtitle>小計{{ this.$store.state.breakdown.medical_medicine_etc.toLocaleString() }}円</v-card-subtitle>
                </v-card>
              </v-col>
              <v-col class="mt-2 d-flex" cols="12" sm="6" md="3" lg="3">
                <v-card class="d-flex flex-column flex-grow-1">
                  <v-card-title>サプリメント</v-card-title>
                  <v-layout justify-center>
                    <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/medical/medical_medicine_supplement.jpg')"></v-img>
                  </v-layout>
                  <v-select small-chips multiple class="d-inline-flex align-center mt-2 ml-4" v-model="$store.state.select.medical_medicine.supplement" :items=this.$store.state.login_response.medical_medicine_supplement item-text="select" item-value="id" return-object label="選択してください" @change="value_medical_medicine_supplement"></v-select>
                  <v-card-subtitle>小計{{ this.$store.state.breakdown.medical_medicine_supplement.toLocaleString() }}円</v-card-subtitle>
                </v-card>
              </v-col>
              <v-col v-if="hasChildren" class="mt-2 d-flex" cols="12" sm="6" md="3" lg="3">
                <v-card class="d-flex flex-column flex-grow-1">
                  <v-card-title>小児医薬品</v-card-title>
                  <v-layout justify-center>
                    <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/medical/medical_medicine_children.jpg')"></v-img>
                  </v-layout>
                  <v-select small-chips multiple class="d-inline-flex align-center mt-2 ml-4" v-model="$store.state.select.medical_medicine.children" :items=this.$store.state.login_response.medical_medicine_children item-text="select" item-value="id" return-object label="選択してください" @change="value_medical_medicine_children"></v-select>
                  <v-card-subtitle>小計{{ this.$store.state.breakdown.medical_medicine_children.toLocaleString() }}円</v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col>小計{{ (this.$store.state.breakdown.medical_medicine_internal + this.$store.state.breakdown.medical_medicine_analgesic + this.$store.state.breakdown.medical_medicine_external + this.$store.state.breakdown.medical_medicine_etc + this.$store.state.breakdown.medical_medicine_supplement + this.$store.state.breakdown.medical_medicine_children).toLocaleString() }}円</v-col>
          <v-col>健康診断</v-col>
          <v-col>
            <v-row>
              <v-col class="mt-2 d-flex" cols="12" sm="6" md="3" lg="3" v-for="(physical, index) in this.$store.state.login_response.medical_physical" :key="index">
                <v-card class="d-flex flex-column flex-grow-1">
                  <v-card-title>{{ physical.item }}<br>{{ physical.cost.toLocaleString() }}円</v-card-title>
                  <v-card-subtitle>{{ physical.note }}</v-card-subtitle>
                  <v-col align="center">
                    <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/medical/'+physical.img+'.jpg')"></v-img>
                  </v-col>
                  <v-card-text>
                    <v-col>
                      {{ physical.content }}
                    </v-col>
                    <br>
                    <v-col>
                      <v-row>
                        <v-select :items=array_physical return-object :label="$store.state.select.medical_physical[index]" dense @change="value_medical_physical(index, $event)"></v-select>
                      </v-row>
                    </v-col>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col>小計{{ this.$store.state.breakdown.medical_physical.reduce((sum, i) => { return sum + i.order; }, 0).toLocaleString() }}円</v-col>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import words from '../assets/words.json'

export default({
  data: () => ({
    icon: 'mdi-pill',
    people: 1,
    array_physical: [],
    dialog: false,
    phrase: {}
  }),
  mounted: function () {
    this.getWords()
  },
  computed: {
    hasChildren () {
      const lr = this.$store.state.login_response
      const persona = lr && lr.persona
      return !!(persona && (Object.prototype.hasOwnProperty.call(persona, 'child1_age') || Object.prototype.hasOwnProperty.call(persona, 'child2_age')))
    },
    analgesic_items () {
      const lr = this.$store.state.login_response || {}
      const list = lr.medical_medicine_analgesic || []
      return list.slice().sort((x, y) => (x.id ?? 0) - (y.id ?? 0))
    },
    help_medical_text () {
      return this.phrase.help_medical
    }
  },
  methods: {
    value_medical_medicine_internal: function(value) {
      this.$store.commit('value_medical_medicine_internal', value);
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    value_medical_medicine_analgesic: function(value) {
      this.$store.commit('value_medical_medicine_analgesic', value);
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    value_medical_medicine_external: function(value) {
      this.$store.commit('value_medical_medicine_external', value);
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    value_medical_medicine_etc: function(value) {
      this.$store.commit('value_medical_medicine_etc', value);
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    value_medical_medicine_supplement: function(value) {
      this.$store.commit('value_medical_medicine_supplement', value);
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    value_medical_medicine_children: function(value) {
      this.$store.commit('value_medical_medicine_children', value);
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    value_medical_physical: function(index, num) {
      this.$store.commit('value_medical_physical', {index, num});
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    getWords: function () {
      this.phrase = words
    }
  },
  created() {
    if(this.$store.state.login_response.persona.is_married == 1) {
      this.people++;
    }
    if('child1_age' in this.$store.state.login_response.persona) {
      this.people++;
    }
    if('child2_age' in this.$store.state.login_response.persona) {
      this.people++;
    }
    this.array_physical = [...Array(this.people+1)].map((_, i) => i);
    this.$store.commit('initialize_medical_physical', this.$store.state.login_response.medical_physical);
  }
})
</script>
